import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { ArtStyleForm } from '../Forms/ArtStyleForm';
import TableHeader from '../../../components/Common/TableHeader';
import { NoRecordFound } from '../../../components/Common/NoRecordFound';
import Dialogs from '../../../components/Common/Dialog';
import { ArtStyleModel } from '../../../interfaces/story.interface';
import { changeArtStyleStatus, getAdminArtStyles } from './services/Artstyle.service';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import { TokenCookieManager } from '../../../utils/tokenCookies';
import { SecureImg } from '../../../components/Common/SecureImage';

const ArtStyles = () => {
  const [artStyleId, setArtStyleId] = useState<string | undefined>(undefined);
  const [openDialog, setOpenDialog] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [artStyles, setArtStyles] = useState<ArtStyleModel[]>([]);
  const [artStyleDetails, setArtStyleDetails] = useState<ArtStyleModel | null>(null);
  const [loading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!TokenCookieManager.hasToken()) {
      navigate('/admin');
    }
  });

  useEffect(() => {
    getAdminArtStyles(setArtStyles);
  }, []);

  useEffect(() => {
    if (artStyleDetails) setShowForm(true);
  }, [artStyleDetails]);

  const handleChangeStatus = async () => {
    if (artStyleId) {
      setOpenDialog(false);
      await changeArtStyleStatus(artStyleId, () => getAdminArtStyles(setArtStyles));
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
  };
  return (
    <div className="p-0 md:p-4">
      {showForm ? (
        <ArtStyleForm
          setShowForm={setShowForm}
          artStyleDetails={artStyleDetails}
          getArtStyles={getAdminArtStyles}
          setArtStyles={setArtStyles}
        />
      ) : (
        <>
          <div>
            <div className="flex justify-between items-baseline flex-wrap gap-2 my-5"></div>
          </div>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <div className="w-full overflow-x-auto">
              <table className="min-w-full border border-gray-300">
                  {TableHeader([
                    'S#',
                    'Name',
                    'Art scene name',
                    'Art Character prompt',
                    'Prompt (old img gen tools)',
                    'Image',
                    'Status',
                    '',
                  ])}
                  <tbody>
                    {artStyles && artStyles?.length > 0 ? (
                      artStyles?.map((artStyle, index) => (
                        <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : ''}>
                          <td className="text-left py-2 px-4 border-b capitalize">{++index}</td>
                          <td className="text-left py-2 px-4 border-b capitalize">{artStyle?.name}</td>
                          <td className="text-left py-2 px-4 border-b">{artStyle?.name_in_scene || ''}</td>
                          <td className="text-left py-2 px-4 border-b max-w-xs lg:max-w-sm">
                            {artStyle?.main_art_character_description || ''}
                          </td>
                          <td className="text-left py-2 px-4 border-b">{artStyle?.sub_prompt}</td>
                          <td className="text-left py-2 px-4 border-b capitalize">
                            <SecureImg
                              storageSrc={artStyle?.sref_image}
                              alt="preview"
                              className="w-[4rem] h-[4rem] rounded-md object-contain mx-auto"
                            />
                          </td>
                          <td className="text-left py-2 px-4 border-b capitalize">
                            {artStyle?.status ? 'Active' : 'In Active'}
                          </td>
                          <td className="text-left py-4 px-4 border-b flex gap-5">
                            <FontAwesomeIcon
                              icon={faPenToSquare}
                              className="cursor-pointer"
                              title="Edit Art Style"
                              onClick={() => setArtStyleDetails(artStyle)}
                            />
                            <FontAwesomeIcon
                              icon={artStyle?.status ? faToggleOn : faToggleOff}
                              className={`h-4 w-6 cursor-pointer ${
                                artStyle?.status === 'active' ? 'text-storygreen' : 'text-red-500'
                              } `}
                              title={artStyle?.status ? 'Deactivate' : 'Activate'}
                              onClick={() => {
                                setOpenDialog(true);
                                setArtStyleId(artStyle.id);
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <NoRecordFound colSpan={6} />
                    )}
                </tbody>
              </table>
            </div>
          )}
          <Dialogs
            openDialog={openDialog}
            handelClose={handleClose}
            confirmMessage={`Are you sure you want to change art style status?`}
            handelProcess={handleChangeStatus}
          />
        </>
      )}
    </div>
  );
};
export default ArtStyles;
